import type { extractAnalyticsDataTypes } from '../analytics-data-extraction';
import { sendEvent } from './lib';

/**
 * flights_homepage_viewed - Пользователь открыл экран Avia
 */
export const homepageViewed = () => {
  sendEvent('flights_homepage_viewed');
};

type Route = {
  arr?: {
    code: string;
  };
  dep?: {
    code: string;
  };
};

/**
 * flights_search_button_clicked - Клик "Найти билеты"
 */
export const searchButtonClicked = (
  params: extractAnalyticsDataTypes.ExtractSearchFormDataParams,
  routes: Route[],
) => {
  const {
    cabin_class,
    passenger_adt,
    passenger_yth,
    passenger_chd,
    passenger_inf,
    city_to,
    city_from,
    travel_type,
    ...rest
  } = params;

  const firstRoute = routes[0];
  const lastRoute = routes[routes.length - 1];

  sendEvent('flights_search_button_clicked', {
    airport_to: lastRoute?.arr?.code,
    airport_from: firstRoute?.dep?.code,
    class: cabin_class,
    count_passenger_adult: passenger_adt,
    count_passenger_youth: passenger_yth,
    count_passenger_child: passenger_chd,
    count_passenger_infant: passenger_inf,
    count_passenger_total:
      passenger_yth > 0
        ? passenger_yth
        : passenger_adt + passenger_chd + passenger_inf,
    city_to: city_to.name,
    city_from: city_from.name,
    travel_type: travel_type === 'I' ? 'international' : 'domestic',
    ...rest,
  });
};
